import type React from "react"

import { Message } from "semantic-ui-react"

type AiWarningProps = {
  content: React.ReactNode
}

const AiWarning = ({ content }: AiWarningProps) => {
  return (
    <Message info color="purple" size="small">
      <Message.Header style={{ marginBottom: 10 }}>✨ AI-powered feature </Message.Header>
      {content}
    </Message>
  )
}

export default AiWarning
